import { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SourceIcon from '@mui/icons-material/Source';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, FormControl, Grid, IconButton, InputAdornment, OutlinedInput, Stack, Tooltip, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {RemoveRedEye} from "@mui/icons-material"
import ClearIcon from '@mui/icons-material/Clear';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useEffect } from 'react';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';

const uploadSingleFilePopup = forwardRef((props, ref) => {
    
    const fileDownloadUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.empDocDownload}`;

    const [open, setOpen] = useState(false);
    const [documentFile, setDocumentFile] = useState([]);
    const [documentName, setDocumentName] = useState("");
    const [openViewDocument,setOpenViewDocument]=useState(false)
    const [documentList,setDocumentList]=useState([])

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDocumentChange = (e) => {
        const file = e.target.files[0];
      setDocumentName(file.name);
        setDocumentFile(file)
        var reader = new FileReader();
        reader.onload = function (upload) {
            setDocumentList([upload.target.result]);
        };
        reader.readAsDataURL(file);
      }

    useEffect(() => {
        if (props?.data) {
            setDocumentName(props?.data?.uploadFile);
            setDocumentFile(props?.data?.file);
            if(props.data.file){
                var reader = new FileReader();
                reader.onload = function (upload) {
                    setDocumentList([upload.target.result]);
                };
                reader.readAsDataURL(props.data.file);
            }
            // setDocumentFile(props.data.file ? props.data.file : []);
        }
    }, [props?.data]);

    const fileDownload = async (name) => {
        const download = await OAuthService.getDownload(fileDownloadUrl + `/${name}`);
        const blob = download?.data
        if (blob) {
            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
            const link = document.createElement('a');
            link.href = url;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
    }

    const removeDocument = () => {
        setDocumentName("");
        setDocumentFile([]);
        setDocumentList([])
    }

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                const rowData = props?.node;
                rowData.setDataValue("file", documentFile);
                return documentName;
            }
        };
    });



    return (
        <div>
            <IconButton onClick={handleClickOpen}><SourceIcon color="warning"/></IconButton>
            <Dialog fullWidth maxWidth={'sm'}
                open={open}
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Upload documents"}</DialogTitle>



                <DialogContent>
                    {!documentName ?
                        <Stack className='w-full mb-16'>
                            <Box className='flex justify-center items-center'
                                sx={{

                                    height: 180,
                                    border: '1px dotted grey',
                                }}
                            >
                                <CloudUploadIcon fontSize={'large'} /><Typography className='ml-12' >Upload your image</Typography>
                                <Button
                                    variant="contained"
                                    component="label"
                                    color="warning"
                                    className='ml-12'
                                >
                                    <input hidden type="file"
                                        onChange={(e) => handleDocumentChange(e)}
                                    />
                                    <Typography color="black">Browse</Typography>
                                </Button>
                            </Box>
                        </Stack>
                        :
                        <Stack className='w-full mb-16'>

                            <Box
                                className='flex justify-between'
                            >
                                <Grid className='flex'>
                                    <div>
                                        <FileCopyIcon color="warning" className=' mt-20' />
                                    </div>
                                    <div>
                                        <Typography className='ml-12 mt-20' >{documentName}</Typography>

                                    </div>
                                </Grid>
                                <Grid>
                                    <Tooltip title={"View file"}>
                                        <IconButton className='mt-20 cursor-pointer' onClick={() => setOpenViewDocument(true)}><RemoveRedEye className='' /></IconButton>
                                    </Tooltip>
                                    <Tooltip title={"Download file"}>
                                        <IconButton className='mt-20 cursor-pointer' onClick={() => fileDownload(documentName)}><FileDownloadIcon className='' /></IconButton>
                                    </Tooltip>
                                    <Tooltip title={"Remove file"}>
                                        <IconButton title='Remove file' className='mt-20 cursor-pointer' onClick={() => removeDocument()}><ClearIcon className='' /></IconButton>
                                    </Tooltip>
                                    {/* <FuseSvgIcon className='mt-20 w-32 h-32 cursor-pointer' onClick={() => removeDocument()}>heroicons-outline:x</FuseSvgIcon> */}
                                </Grid>
                            </Box>
                        </Stack>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                    {/* <Button onClick={handleClose}>Uplaod</Button> */}
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth={true}
                onClose={()=>setOpenViewDocument(false)}
                open={openViewDocument}
            >
                <DialogTitle>
                    <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                        <Button onClick={()=>setOpenViewDocument(false)}>
                            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                        </Button>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                        <img src={documentList?.[0]} alt={documentName} />
                </DialogContent>
            </Dialog>
        </div>
    )
})

export default uploadSingleFilePopup